export default __webpack_public_path__ + "static/media/WhatsThePoint_0323.e26ed790.svg";